import { DEFAULT_LANGUAGE } from 'Store/internationalization/constants';

import arDesktop from './ar/swipe_grid_background_desktop.jpg';
import arDesktopSmall from './ar/swipe_grid_background_desktop_30pct_blur.jpg';
import arMobile from './ar/swipe_grid_background_mobile.jpg';
import arMobileSmall from './ar/swipe_grid_background_mobile_30pct_blur.jpg';
import deDesktop from './de/swipe_grid_background_desktop.jpg';
import deDesktopSmall from './de/swipe_grid_background_desktop_30pct_blur.jpg';
import deMobile from './de/swipe_grid_background_mobile.jpg';
import deMobileSmall from './de/swipe_grid_background_mobile_30pct_blur.jpg';
import enGBDesktop from './en-GB/swipe_grid_background_desktop.jpg';
import enGBDesktopSmall from './en-GB/swipe_grid_background_desktop_30pct_blur.jpg';
import enGBMobile from './en-GB/swipe_grid_background_mobile.jpg';
import enGBMobileSmall from './en-GB/swipe_grid_background_mobile_30pct_blur.jpg';
import enINDesktop from './en-IN/swipe_grid_background_desktop.jpg';
import enINDesktopSmall from './en-IN/swipe_grid_background_desktop_30pct_blur.jpg';
import enINMobile from './en-IN/swipe_grid_background_mobile.jpg';
import enINMobileSmall from './en-IN/swipe_grid_background_mobile_30pct_blur.jpg';
import enUSDesktop from './en-US/swipe_grid_background_desktop.jpg';
import enUSDesktopSmall from './en-US/swipe_grid_background_desktop_30pct_blur.jpg';
import enUSMobile from './en-US/swipe_grid_background_mobile.jpg';
import enUSMobileSmall from './en-US/swipe_grid_background_mobile_30pct_blur.jpg';
import enDesktop from './en/swipe_grid_background_desktop.jpg';
import enDesktopSmall from './en/swipe_grid_background_desktop_30pct_blur.jpg';
import enMobile from './en/swipe_grid_background_mobile.jpg';
import enMobileSmall from './en/swipe_grid_background_mobile_30pct_blur.jpg';
import esDesktop from './es/swipe_grid_background_desktop.jpg';
import esDesktopSmall from './es/swipe_grid_background_desktop_30pct_blur.jpg';
import esMobile from './es/swipe_grid_background_mobile.jpg';
import esMobileSmall from './es/swipe_grid_background_mobile_30pct_blur.jpg';
import frDesktop from './fr/swipe_grid_background_desktop.jpg';
import frDesktopSmall from './fr/swipe_grid_background_desktop_30pct_blur.jpg';
import frMobile from './fr/swipe_grid_background_mobile.jpg';
import frMobileSmall from './fr/swipe_grid_background_mobile_30pct_blur.jpg';
import heDesktop from './he/swipe_grid_background_desktop.jpg';
import heDesktopSmall from './he/swipe_grid_background_desktop_30pct_blur.jpg';
import heMobile from './he/swipe_grid_background_mobile.jpg';
import heMobileSmall from './he/swipe_grid_background_mobile_30pct_blur.jpg';
import idDesktop from './id/swipe_grid_background_desktop.jpg';
import idDesktopSmall from './id/swipe_grid_background_desktop_30pct_blur.jpg';
import idMobile from './id/swipe_grid_background_mobile.jpg';
import idMobileSmall from './id/swipe_grid_background_mobile_30pct_blur.jpg';
import jaDesktop from './ja/swipe_grid_background_desktop.jpg';
import jaDesktopSmall from './ja/swipe_grid_background_desktop_30pct_blur.jpg';
import jaMobile from './ja/swipe_grid_background_mobile.jpg';
import jaMobileSmall from './ja/swipe_grid_background_mobile_30pct_blur.jpg';
import koDesktop from './ko/swipe_grid_background_desktop.jpg';
import koDesktopSmall from './ko/swipe_grid_background_desktop_30pct_blur.jpg';
import koMobile from './ko/swipe_grid_background_mobile.jpg';
import koMobileSmall from './ko/swipe_grid_background_mobile_30pct_blur.jpg';
import middleEastDesktop from './middle-east/swipe_grid_background_desktop.jpg';
import middleEastDesktopSmall from './middle-east/swipe_grid_background_desktop_30pct_blur.jpg';
import middleEastMobile from './middle-east/swipe_grid_background_mobile.jpg';
import middleEastMobileSmall from './middle-east/swipe_grid_background_mobile_30pct_blur.jpg';
import seaDesktop from './sea/swipe_grid_background_desktop.jpg';
import seaDesktopSmall from './sea/swipe_grid_background_desktop_30pct_blur.jpg';
import seaMobile from './sea/swipe_grid_background_mobile.jpg';
import seaMobileSmall from './sea/swipe_grid_background_mobile_30pct_blur.jpg';
import thDesktop from './th/swipe_grid_background_desktop.jpg';
import thDesktopSmall from './th/swipe_grid_background_desktop_30pct_blur.jpg';
import thMobile from './th/swipe_grid_background_mobile.jpg';
import thMobileSmall from './th/swipe_grid_background_mobile_30pct_blur.jpg';
import viDesktop from './vi/swipe_grid_background_desktop.jpg';
import viDesktopSmall from './vi/swipe_grid_background_desktop_30pct_blur.jpg';
import viMobile from './vi/swipe_grid_background_mobile.jpg';
import viMobileSmall from './vi/swipe_grid_background_mobile_30pct_blur.jpg';
import zhHansDesktop from './zh-Hans/swipe_grid_background_desktop.jpg';
import zhHansDesktopSmall from './zh-Hans/swipe_grid_background_desktop_30pct_blur.jpg';
import zhHansMobile from './zh-Hans/swipe_grid_background_mobile.jpg';
import zhHansMobileSmall from './zh-Hans/swipe_grid_background_mobile_30pct_blur.jpg';
import zhHantDesktop from './zh-Hant/swipe_grid_background_desktop.jpg';
import zhHantDesktopSmall from './zh-Hant/swipe_grid_background_desktop_30pct_blur.jpg';
import zhHantMobile from './zh-Hant/swipe_grid_background_mobile.jpg';
import zhHantMobileSmall from './zh-Hant/swipe_grid_background_mobile_30pct_blur.jpg';

const availableConfig = {
  ar: {
    desktop: {
      s: arDesktopSmall,
      l: arDesktop,
    },
    mobile: {
      s: arMobileSmall,
      l: arMobile,
    },
  },
  de: {
    desktop: {
      s: deDesktopSmall,
      l: deDesktop,
    },
    mobile: {
      s: deMobileSmall,
      l: deMobile,
    },
  },
  en: {
    desktop: {
      s: enDesktopSmall,
      l: enDesktop,
    },
    mobile: {
      s: enMobileSmall,
      l: enMobile,
    },
  },
  'en-GB': {
    desktop: {
      s: enGBDesktopSmall,
      l: enGBDesktop,
    },
    mobile: {
      s: enGBMobileSmall,
      l: enGBMobile,
    },
  },
  'en-IN': {
    desktop: {
      s: enINDesktopSmall,
      l: enINDesktop,
    },
    mobile: {
      s: enINMobileSmall,
      l: enINMobile,
    },
  },
  'en-US': {
    desktop: {
      s: enUSDesktopSmall,
      l: enUSDesktop,
    },
    mobile: {
      s: enUSMobileSmall,
      l: enUSMobile,
    },
  },
  es: {
    desktop: {
      s: esDesktopSmall,
      l: esDesktop,
    },
    mobile: {
      s: esMobileSmall,
      l: esMobile,
    },
  },
  fr: {
    desktop: {
      s: frDesktopSmall,
      l: frDesktop,
    },
    mobile: {
      s: frMobileSmall,
      l: frMobile,
    },
  },
  he: {
    desktop: {
      s: heDesktopSmall,
      l: heDesktop,
    },
    mobile: {
      s: heMobileSmall,
      l: heMobile,
    },
  },
  id: {
    desktop: {
      s: idDesktopSmall,
      l: idDesktop,
    },
    mobile: {
      s: idMobileSmall,
      l: idMobile,
    },
  },
  ja: {
    desktop: {
      s: jaDesktopSmall,
      l: jaDesktop,
    },
    mobile: {
      s: jaMobileSmall,
      l: jaMobile,
    },
  },
  ko: {
    desktop: {
      s: koDesktopSmall,
      l: koDesktop,
    },
    mobile: {
      s: koMobileSmall,
      l: koMobile,
    },
  },
  'middle-east': {
    desktop: {
      s: middleEastDesktopSmall,
      l: middleEastDesktop,
    },
    mobile: {
      s: middleEastMobileSmall,
      l: middleEastMobile,
    },
  },
  sea: {
    desktop: {
      s: seaDesktopSmall,
      l: seaDesktop,
    },
    mobile: {
      s: seaMobileSmall,
      l: seaMobile,
    },
  },
  th: {
    desktop: {
      s: thDesktopSmall,
      l: thDesktop,
    },
    mobile: {
      s: thMobileSmall,
      l: thMobile,
    },
  },
  vi: {
    desktop: {
      s: viDesktopSmall,
      l: viDesktop,
    },
    mobile: {
      s: viMobileSmall,
      l: viMobile,
    },
  },
  'zh-Hans': {
    desktop: {
      s: zhHansDesktopSmall,
      l: zhHansDesktop,
    },
    mobile: {
      s: zhHansMobileSmall,
      l: zhHansMobile,
    },
  },
  'zh-Hant': {
    desktop: {
      s: zhHantDesktopSmall,
      l: zhHantDesktop,
    },
    mobile: {
      s: zhHantMobileSmall,
      l: zhHantMobile,
    },
  },
};

export const getBackgroundByVariant = (variant: string, device: string) => {
  // eslint-disable-line
  const config = availableConfig[variant] || availableConfig[DEFAULT_LANGUAGE];
  return config[device];
};
